// 查询每个区域包含的设备\
import request from "@/util/request.js";
export const areaBranch = (token, areaId) => {
  return request.post("api/sansint-energy/electricSence/areaBranch", {
    token,
    areaId
  });
};

export const branchInfo = (token, branchId) => {
  return request.post("api/sansint-energy/electricSence/branchInfo", {
    token,
    branchId
  });
};
// 设备开关
export const pubMsg = (
  collectorSerial,
  branchCode,
  conVal,
  subStr,
  branchId
) => {
  return request.post("/api/sansint-energy/electricSence/pubMsg", {
    collectorSerial,
    branchCode,
    conVal,
    subStr,
    branchId
  });
};
export const branchRealTimeData = (token, branchId) => {
  return request.post("/api/sansint-energy/electricSence/branchRealTimeData", {
    token,
    branchId
  });
};
//漏电自检
export const pubMsgBreakZj = (
  collectorSerial,
  branchCode,
  conVal,
  subStr,
  branchId
) => {
  return request.post("/api/sansint-energy/electricSence/pubMsgBreakZj", {
    collectorSerial,
    branchCode,
    conVal,
    subStr,
    branchId
  });
};
//漏电自检
export const sendScheduleBreakStrategy = (
  collectorSerial,
  branchCode,
  subStr,
  branchId,
  lineP,
  openTime,
  closeTime
) => {
  return request.post(
    "/api/sansint-energy/break/strategy/sendScheduleBreakStrategy",
    [
      {
        collectorSerial,
        branchCode,
        subStr,
        branchId,
        lineP,
        openTime,
        closeTime,
        tagIdLineP: "limit_p_alarm_value"
      }
    ]
  );
};
